import { GENDER, UPPER_AGE_LIMIT, UPPER_AGE_LIMIT_PER_PRODUCT } from 'constants/constants';
import ServiceManager from '../services/ServiceManager';

export const checkIfEmailIsInUse = async (contactId: string, email: string): Promise<boolean> => {
    try {
        const { data: isEmailExist } = await ServiceManager.customClientService('checkIfEmailIsInUse', [{ contactId, email }]);

        return isEmailExist;
    } catch (err) {
        return false;
    }
};

export const getUpperAgeLimit = (gender: string): number => (gender === GENDER.male ? UPPER_AGE_LIMIT.male : UPPER_AGE_LIMIT.female);
export const getUpperAgeLimitPerProduct = (gender: string, product: string): number | undefined => (UPPER_AGE_LIMIT_PER_PRODUCT[product]?.[gender]);
export const PAYMENT_PERIODS = {
    yearly: {
        id: 3,
        label: 'portfolio.createNewPortfolio.yearly',
        value: 1,
    },
    semiYearly: {
        id: 2,
        label: 'portfolio.createNewPortfolio.semiYearly',
        value: 2,
    },
    quarterly: {
        id: 1,
        label: 'portfolio.createNewPortfolio.quarterly',
        value: 4,
    },
    monthly: {
        id: 0,
        label: 'portfolio.createNewPortfolio.monthly',
        value: 12,
    },
};

export const getPaymentPeriodValue = (id: string | number): number => (Object.values(PAYMENT_PERIODS).find((f) => f.id === parseInt(String(id), 10))?.value || NaN);

export const calculatePlannedInvestment = (initialInvestment: number, periodicPayment: number, periodicity: string | number): number => initialInvestment + (periodicPayment * getPaymentPeriodValue(periodicity));

export const checkIfEmailIsAvailable = async (email: string): Promise<boolean> => {
    try {
        const { data: isEmailInUse } = await ServiceManager.customClientService('checkIfEmailIsAvailable', [{ email }]);

        return !isEmailInUse;
    } catch (err) {
        return true;
    }
};

export const merge = <T, U>(
    a: T[],
    b: U[],
    predicate: (aItem: U, bItem: T) => boolean = (aItem, bItem) => aItem === (bItem as unknown as U),
): Array<T | U> => {
    const c: Array<T | U> = [...a];

    b.forEach((bItem) => (c.some((cItem) => predicate(bItem, cItem as T)) ? null : c.push(bItem)));

    return c;
};
